import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

export default function PaymentCreditCardForm() {
	// Selectors
	const { creditCardResponse } = useSelector((state) => state.cart);
	// Ref
	const formRef = useRef();
	// Effect
	useEffect(() => {
		formRef.current.submit();
	}, []);
	// Render functions
	function renderFormInputs() {
		return Object.keys(creditCardResponse).map((name, index) => {
			if (name !== "Url") {
				return (
					<input key={index} name={name} type="hidden" value={creditCardResponse[name]} />
				);
			} else {
				return null;
			}
		});
	}
	const { Url } = creditCardResponse;
	// Render
	return (
		<form ref={formRef} action={Url} method="post">
			{renderFormInputs()}
		</form>
	);
}
